import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const SearchContainer = styled.div`
  max-inline-size: 720px;
  margin-block-end: 60px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 20%;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-inline: auto;
  }
`;
